import { render, staticRenderFns } from "./BlocoImovel.vue?vue&type=template&id=5d9e7ffe&scoped=true&lang=pug"
import script from "./BlocoImovel.vue?vue&type=script&lang=js"
export * from "./BlocoImovel.vue?vue&type=script&lang=js"
import style0 from "./BlocoImovel.vue?vue&type=style&index=0&id=5d9e7ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9e7ffe",
  null
  
)

export default component.exports